import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SwapNotification = ({ show, onDismiss, reason }) => (
  <AnimatePresence>
    {show && (
      <div 
        className="fixed z-[220] inset-x-0 pointer-events-none flex justify-center md:justify-end md:pr-6" 
        style={{ top: 'clamp(70px, 10vh, 90px)' }}
      >
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.9 }}
          className="pointer-events-auto"
          onClick={onDismiss}
        >
          <div
            className="flex items-center gap-3 px-5 py-3.5 rounded-2xl border shadow-2xl cursor-pointer active:scale-95 transition-transform"
            style={{
              background: 'rgba(13, 26, 46, 0.97)',
              borderColor: 'rgba(99, 102, 241, 0.5)',
              backdropFilter: 'blur(12px)',
            }}
          >
            <span className="text-2xl">↔️</span>
            <div>
              <p className="text-sm font-black text-indigo-300">換邊提醒</p>
              <p className="text-xs text-white/50 font-bold">{reason}</p>
            </div>
            <button className="text-white/30 hover:text-white/60 ml-2 text-lg">×</button>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default SwapNotification;